export class ListPresencesRequest {

    _workerId; // number
    _constructionId; // boolean
    _retrieveWorkerDocumentationState; // boolean
    _term; // string
    _page; // number
    _skipPagination; // boolean
    _limit; // number
    _date; // PsDate;
    _month;
    _year;
    _companyId;

    constructor() {
        this._workerId = undefined;
        this._constructionId = undefined;
        this._retrieveWorkerDocumentationState = undefined;
        this._term = undefined;
        this._page = undefined;
        this._skipPagination = undefined;
        this._limit = undefined;
        this._date = undefined;
        this._month = undefined;
        this._year = undefined;
        this._companyId = undefined;
    }

    setWorkerId(workerId) {
        this._workerId = workerId;
    }

    setConstructionId(constructionId) {
        this._constructionId = constructionId;
    }

    setRetrieveWorkerDocumentationState(retrieveWorkerDocumentationState) {
        this._retrieveWorkerDocumentationState = retrieveWorkerDocumentationState;
    }

    setTerm(term) {
        this._term = term;
    }

    setDate(date) {
        this._date = date;
    }

    setPage(page) {
        this._page = page;
    }

    setSkipPagination(skipPagination) {
        this._skipPagination = skipPagination;
    }

    setLimit(limit) {
        this._limit = limit;
    }

    setMonth(month) {
        this._month = month;
    }

    setYear(year) {
        this._year = year;
    }

    setCompanyId(companyId) {
        this._companyId = companyId
    }

    body() {
        let dateTime;
        if ( this._date ) {
            dateTime = this._date.toISOFirstTime();
        }
        const date = dateTime ? dateTime.split('T')[0] : undefined;

        return {
            criteria: {
                worker_id: this._workerId,
                construction_id: this._constructionId,
                retrieve_worker_documentation_state: this._retrieveWorkerDocumentationState,
                term: this._term,
                page: this._page,
                skip_pagination: this._skipPagination,
                limit: this._limit,
                date: date,
                companies_only_active: true,
                month: this._month,
                year: this._year,
                company_id: this._companyId,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/webservices/list-presence/ListPresencesRequest.js